import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { TravelApprovalReasonModal } from '@/module/Travel/Approval/components/TravelApprovalReasonModal';

import { useTravelRequestCancel } from '../model/TravelRequestQuery';
import { TravelRequest } from '../model/TravelRequestTypes';

interface TravelRequestCancelButtonProps {
  request: TravelRequest;
}

// Who may cancel is the server's call, so the button follows its flag and never the viewer's role.
export function TravelRequestCancelButton({ request }: TravelRequestCancelButtonProps) {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const mutation = useTravelRequestCancel(request.id);

  if (!request.canCancel) {
    return null;
  }

  return (
    <>
      <Button
        size="xs"
        color="red"
        variant="outline"
        leftSection={<IconX size={14} />}
        onClick={open}
      >
        {t('travel.requests.actions.cancel')}
      </Button>
      {opened && (
        <TravelApprovalReasonModal
          action="cancel"
          title={t('travel.requests.actions.confirmCancel.title')}
          content={t('travel.requests.actions.confirmCancel.content')}
          mutation={mutation}
          onClose={close}
        />
      )}
    </>
  );
}
